import React from "react";
import { withRouter } from "react-router-dom";
import SoilTestsDetails from "./SoilTestsDetails";

const _getSoilTests = (budget, soilTestsId) => {
    let soilTests = (budget.soilTests || []).find((st) => st.id === soilTestsId);
    if (!soilTests) return undefined;

    const applications = budget.blocks
        .filter((b) => b.soilTestId === soilTestsId)
        .map((b) => {
            return { id: b.id, block: b };
        });

    return {
        ...soilTests,
        applications: applications,
    };
};

const SoilTestsEdit = (props) => {
    const { budget } = props;
    const soilTestsId = props.match.params.soilTestsId;

    const soilTests = _getSoilTests(budget, soilTestsId);

    return <SoilTestsDetails {...props} soilTests={soilTests} />;
};

export default withRouter(SoilTestsEdit);
